import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectVersionsRoute: InvariantJiraRoute = {
	name: 'project-versions',
	path: '/projects/:projectKey',
	query: ['selectedItem=com.atlassian.jira.jira-projects-plugin:release-page'],
};
